import React from 'react';
import { Button, Col, Grid, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, lifecycle, renderNothing, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { businessActions, businessSelector } from '../../../../state/modules/business';
import { Icon } from '../../../components';
import ContentTable from '../../shared/publish-content/content-table';
import NonCpdContentTable from '../../shared/publish-content/non-cpd-content-table';


const BusinessLibrary = ({
  getBusinessContent,
  deleteBusinessContent,
  archiveBusinessContent,
  contentResult,
  isFetchingContent,
  isFetching,
  contentDetailsRoute,
  nonCpdContent
}) => (
    <div className='base-layout'>
      <section id='header--publishers' className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12}>
              <h1>Welcome to your business library</h1>
            </Col>
          </Row>
          <Row className='button-gutter'>
            <Col xs={12} md={6}>
              <h2>Upload professional development content and share it with your team</h2>
              <p>Caddie gives you the power to deliver professional development content and quiz’s to your team so you can track it against their CPD obligations. Upload articles, videos, podcasts, webinars, PDFs and more in three simple steps - It’s that easy!</p>
            </Col>
          </Row>
        </Grid>
      </section>
      <section id='section--publishers' className='layout--section'>
        <Grid>
          <section id='publishers--your-caddie-links' className='publishers--dashboard'>
            <Row className='xs-gutter mobile-boxed'>
              <Col xs={12} md={6}>
                <h1><Icon icon='caddie-links-large-alt' /> Your Content</h1>
                <p>Add or manage Content.</p>
              </Col>
              <Col xs={12} md={3}>
                <LinkContainer className='large full pull-down' to={routes.app.library.contentDetails}>
                  <Button>
                    <Icon icon='add-large' /> Add Content
                  </Button>
                </LinkContainer>
              </Col>
              <Col xs={12} md={3}>
                <LinkContainer className='large full pull-down' to={routes.app.library.content}>
                  <Button>
                    See all Content <Icon icon='chevron-right-large' />
                  </Button>
                </LinkContainer>
              </Col>
            </Row>
            <Tabs id='content-table-tabs' className='top-gap'>
              <Tab eventKey='content' title='CPD Content'>
                <ContentTable
                  hideIndustries={true}
                  contentResult={contentResult}
                  isFetchingContent={isFetchingContent}
                  isFetching={isFetching}
                  contentDetailsRoute={contentDetailsRoute}
                  getContent={getBusinessContent}
                  deleteContent={deleteBusinessContent}
                  archiveContent={archiveBusinessContent}
                  contentPerPage={6} />
              </Tab>
              <Tab eventKey='non-cpd-content' title='Non CPD Content'>
                <NonCpdContentTable
                  hideIndustries={true}
                  contentResult={nonCpdContent}
                  contentDetailsRoute={contentDetailsRoute}
                  archiveContent={archiveBusinessContent}
                  deleteContent={deleteBusinessContent} />
              </Tab>
            </Tabs>
          </section>
        </Grid>
      </section>
    </div>
  )

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  contentDetailsRoute: routes.app.library.contentDetails,
  contentResult: state.business.content.contentResult,
  nonCpdContent: state.business.content.nonCpdContent,
  isFetchingContent: state.business.content.isFetching,
  isFetching: state.cpdCategorys.isFetching ||
    state.business.content.isFetching ||
    state.business.content.isLoadingMore
});

const mapDispatchToProps = (dispatch) => ({
  getContent: bindActionCreators(businessActions.business.content.get, dispatch),
  getNonCpdContent: bindActionCreators(businessActions.business.content.getNonCpdContent, dispatch),
  deleteContent: bindActionCreators(businessActions.business.content.deleteContent, dispatch),
  archiveContent: bindActionCreators(businessActions.business.content.archiveContent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderNothing
  ),
  withHandlers({
    getBusinessContent: ({ business, getContent }) => () => {
      getContent(business.id)
    },
    deleteBusinessContent: ({ business, deleteContent }) => (contentId, currentContentQuery) => {
      deleteContent(business.id, contentId, currentContentQuery)
    },
    archiveBusinessContent: ({ business, archiveContent }) => (contentId) => {
      archiveContent(business.id, contentId)
    }
  }),
  lifecycle({
    componentDidMount() {
      const {
        getNonCpdContent,
        business
      } = this.props

      getNonCpdContent(business.id)
    }
  })
)(BusinessLibrary);



// WEBPACK FOOTER //
// ./src/containers/pages/app/business-library/dashboard.js